// extracted by mini-css-extract-plugin
export var notificationHost = "_dl-0";